import { render, staticRenderFns } from "./BookingLotArticleForm.vue?vue&type=template&id=21fb81d4&"
import script from "./BookingLotArticleForm.vue?vue&type=script&lang=js&"
export * from "./BookingLotArticleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports